import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  roleList: [],
  roleFormList: [],
  roleDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
      state.loading = false;
      state.success = false;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchRoleList(state, action) {
      state.roleList = action.payload;
      state.loading = false;
    },
    fetchRoleFormList(state, action) {
      state.roleFormList = action.payload;
      state.loading = false;
    },
    fetchRoleDetail(state, action) {
      state.roleDetail = action.payload;
      state.loading = false;
    },
  },
});

export const roleActions = roleSlice.actions;

export default roleSlice.reducer;
